import React, { ComponentProps } from 'react';
import { Square } from '@grubhubprod/gh-cookbook-react';
import { useDataTableContext } from 'src/components/DataTable/components/DataTableProvider/hooks/useDataTableContext';

type SquareProps = ComponentProps<typeof Square>;

export type DataTableContainerProps = Partial<Pick<SquareProps, 'overflow'>>;

export const DataTableContainer: React.FC<DataTableContainerProps> = ({
  children,
  overflow,
}) => {
  const { isError, isEmpty } = useDataTableContext();

  const defaultOverflow = isError || isEmpty ? 'hidden' : 'visible';

  return (
    <Square
      dimension="1"
      borderRadius="4px"
      bg="untintedBackground"
      overflow={overflow ?? defaultOverflow}
    >
      {children}
    </Square>
  );
};
